module.exports = __webpack_public_path__ + "img/cranberry-orange-muffins.c47f3fb3.jpg";